let { View } = window.App;

const SELECTOR = '.js-accordions';

class Accordions{
    constructor( el ){
        this.el = el;
        this.$el = $( el );

        this.$accordions = this.$el.find( SELECTOR + '__single' );
        this.$buttons = this.$el.find( SELECTOR + '__button' );
        this.$contents = this.$el.find( SELECTOR + '__content' );

        this.$buttons.on( 'click', $.proxy( this.clickButton, this ) );
    }

    clickButton( e ){
        let $target = $( e.currentTarget );

        let $clicked_accordion = $target.closest( this.$accordions );

        if( $clicked_accordion.hasClass( '__active' ) ){
            this.closeAccordion( $clicked_accordion );
        }else{
            this.openAccordion( $clicked_accordion );
        }
    }

    closeAccordion( $accordions ){
        $accordions
            .removeClass( '__active' )
            .find( this.$contents )
            .stop()
            .slideUp( 300 );
    }

    openAccordion( $accordion ){
        $accordion = $accordion.eq( 0 );

        $accordion
            .addClass( '__active' )
            .find( this.$contents )
            .stop()
            .slideDown( 300 );

        this.closeAccordion( this.$accordions.not( $accordion ) );
    }
}

View.addHook( 'init', v => {
    v.$( SELECTOR ).each( function(){
        new Accordions( this );
    } );
} )



// WEBPACK FOOTER //
// ./resources/js/modules/accordions.js